import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environment.ts/environment';

export interface PaymentIntentRequest {
  amount: number;
  currency: string;
  payment_method_id: string;
  customer_id?: string;
  id_site?: number;
  metadata?: {
    filename?: string;
    email?: string;
    product?: string;
  };
}

export interface PaymentIntentResponse {
  success: boolean;
  client_secret?: string;
  payment_intent_id?: string;
  error?: string;
  message?: string;
}

export interface PaymentConfirmationRequest {
  payment_intent_id?: string;
  payment_method_id?: string;
  customer_id?: string;
  id_site?: number;
}

export interface CustomerData {
  email: string;
  id_site?: number;
  metadata?: {
    filename?: string;
    email?: string;
    product?: string;
  };
}

export interface CustomerResponse {
  success: boolean;
  customer_id?: string;
  customer_email?: string;
  customer_name?: string;
  error?: string;
  message?: string;
}

export interface SubscriptionRequest {
  customer_id?: string;
  id_site?: number;
}

export interface SubscriptionResponse {
  success: boolean;
  subscription_id?: string;
  customer_id?: string;
  status?: string;
  current_period_start?: number;
  current_period_end?: number;
  trial_end?: number;
  error?: string;
  message?: string;
  timestamp?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private readonly apiBaseUrl = environment.fileConverterBaseUrl;

  constructor(private http: HttpClient) {}

  /**
   * Crée un customer Stripe
   * @param customerData - Les données du customer
   * @returns Observable<CustomerResponse> - La réponse de l'API
   */
  createCustomer(customerData: CustomerData): Observable<CustomerResponse> {
    return this.http.post<CustomerResponse>(
      `${this.apiBaseUrl}/api/stripe/customers`,
      customerData
    );
  }

  /**
   * Crée une intention de paiement côté backend
   * @param paymentData - Les données de paiement
   * @returns Observable<PaymentIntentResponse> - La réponse de l'API
   */
  createPaymentIntent(paymentData: PaymentIntentRequest): Observable<PaymentIntentResponse> {
    return this.http.post<PaymentIntentResponse>(
      `${this.apiBaseUrl}/api/stripe/create-intent`,
      paymentData
    );
  }

  /**
   * Confirme un paiement côté backend
   * @param confirmationData - Les données de confirmation
   * @returns Observable<any> - La réponse de l'API
   */
  confirmPayment(confirmationData: PaymentConfirmationRequest): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/api/stripe/confirm`,
      confirmationData
    );
  }

  /**
   * Crée une subscription Stripe pour un customer
   * @param subscriptionData - Les données de subscription
   * @returns Observable<SubscriptionResponse> - La réponse de l'API
   */
  createSubscription(subscriptionData: SubscriptionRequest): Observable<SubscriptionResponse> {
    return this.http.post<SubscriptionResponse>(
      `${this.apiBaseUrl}/api/stripe/subscriptions`,
      subscriptionData
    );
  }

  /**
   * Crée un enregistrement de transaction
   * @param transactionData - Les données de transaction
   * @returns Observable<any> - La réponse de l'API
   */
  createTransaction(transactionData: any): Observable<any> {
    return this.http.post(
      `${this.apiBaseUrl}/api/transactions`,
      transactionData
    );
  }
} 